import React from "react";

const NotFound = () => (
  <div>
    <h2>Error 404:  Page Not Found</h2>
  </div>
);

export default NotFound;
